// extracted by mini-css-extract-plugin
export default {"mainContainer":"ManageServices_mainContainer__Ff8tT","leftBody":"ManageServices_leftBody__R4tE4","centerBody":"ManageServices_centerBody__HezC5"};